import React from 'react';
import { MenuCategoryList } from 'widgets/menu';

export const MenuPage: React.FC = React.memo(() => {
  return <MenuCategoryList />;
});
